import Modal from '@mui/material/Modal';
import {useSelector} from 'react-redux';
import AdminModal from './Modals/AdminModal';
import CardModal from './Modals/CardModal';
import ComplexModal from './Modals/ComplexModal';
import CustomerModal from './Modals/CustomerModal';
import DeleteModal from './Modals/DeleteModal';
import ElevatorModal from './Modals/ElevatorModal';
import EntranceModal from './Modals/EntranceModal';
import GarageModal from './Modals/GarageModal';
import CustomerGarageModal from './Modals/CustomerGarageModal';
import PaymentModal from './Modals/PaymentModal';
import UpdatePasswordModal from './Modals/UpdatePasswordModal';
import ModalLayout from './Modals/ModalLayout';
import SupervisorModal from './Modals/SupervisorModal';

const EditComplexModal = () => <ComplexModal edit />;
const EditElevatorModal = () => <ElevatorModal edit />;
const EditEntranceModal = () => <EntranceModal edit />;
const EditGarageModal = () => <GarageModal edit />;
const EditCustomerGarageModal = () => <CustomerGarageModal edit />;

const MODALS = {
  AddAdminModal: AdminModal,
  AddSupervisorModal: SupervisorModal,
  CardModal,
  AddComplexModal: ComplexModal,
  EditComplexModal,
  CustomerModal,
  AddEntranceModal: EntranceModal,
  EditEntranceModal,
  AddGarageModal: GarageModal,
  EditGarageModal,
  CustomerGarageModal,
  EditCustomerGarageModal,
  AddElevatorModal: ElevatorModal,
  EditElevatorModal,
  DeleteModal,
  UpdatePasswordModal,
  PaymentModal,
};

const ModalsManager = () => {
  const {openedModal} = useSelector(s => s.modal);
  const ModalClass = MODALS[openedModal];

  return (
    <Modal
      open={Boolean(openedModal)}
      keepMounted
      sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <ModalLayout>{!!openedModal && <ModalClass />}</ModalLayout>
    </Modal>
  );
};

export default ModalsManager;
